export const SET_YANDEX_MAP_TOKEN = 'SET_YANDEX_MAP_TOKEN';

export const setYandexMapToken = (token: string) => ({
    type: SET_YANDEX_MAP_TOKEN,
    payload: { token },
});
